import { $get, $post } from '@/request/axios';
// JSSDK初始化
export function getJssdkConfig (param, that) {
  return $post({
    url: 'wechat/wxJsSignature',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 微信注册登录
export function register (param, that) {
  return $post({
    url: 'wechat/register',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 发验证码
export function getRegCode (param, that) {
  return $post({
    url: 'wechat/getRegCode',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 微信注册登录
export function chkRegCode (param, that) {
  return $post({
    url: 'wechat/chkRegCode',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 获取用户信息
export function getUserInfo (param, that) {
  return $get({
    url: 'user/getUserInfo',
    method: 'get',
    data: param,
    that: that,
    loading: true
  });
}
// 获取会员信息
export function getMemberfo (param, that) {
  return $get({
    url: 'member/info',
    method: 'get',
    data: param,
    that: that,
    loading: true
  });
}
// 添加会话窗口
export function windowAdd (param, that) {
  return $post({
    url: 'window/add',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 发送消息
export function sessionList (param, that) {
  return $get({
    url: 'session/list',
    method: 'get',
    data: param,
    that: that,
    loading: true
  });
}
// 发送消息
export function windowList (param, that) {
  return $get({
    url: 'window/list',
    method: 'get',
    data: param,
    that: that,
    loading: true
  });
}
// 获取AI列表
export function addList (param, that) {
  return $get({
    url: 'app/list',
    method: 'get',
    data: param,
    that: that,
    loading: false
  });
}
// 获取AI分类列表
export function appTypeList (param, that) {
  return $get({
    url: 'appType/list',
    method: 'get',
    data: param,
    that: that,
    loading: false
  });
}
// 修改
export function windowUpdate (param, that) {
  return $post({
    url: 'window/update',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 删除
export function windowDelete (param, that) {
  return $post({
    url: 'window/delete',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 搜索AI分类列表
export function searchAppTypeList (param, that) {
  return $get({
    url: 'app/searchList',
    method: 'get',
    data: param,
    that: that,
    loading: true
  });
}
// 获取APP信息
export function appAppDate (param, that) {
  return $get({
    url: 'app/appDate',
    method: 'get',
    data: param,
    that: that,
    loading: true
  });
}
// 收藏取消收藏
export function appAppLike (param, that) {
  return $get({
    url: 'app/appLike',
    method: 'get',
    data: param,
    that: that,
    loading: false
  });
}
// 退出
export function userLogout (param, that) {
  return $post({
    url: 'user/logout',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 收藏取消收藏
export function clearSession (param, that) {
  return $get({
    url: 'session/clear',
    method: 'get',
    data: param,
    that: that,
    loading: true
  });
}
// 发送消息
export function sessiongetMessage (param, that) {
  return $post({
    url: 'session/getMessage',
    method: 'post',
    data: param,
    that: that,
    loading: false
  });
}
// // 获取商品（套餐列表）
// export function wechatPayGoods (param, that) {
//   return $get({
//     url: 'wechatPay/goods',
//     method: 'get',
//     data: param,
//     that: that
//   });
// }
// 获取商品（套餐列表）
export function wechatPayGoods (param, that) {
  return $get({
    url: 'wechatPay/goodsType',
    method: 'get',
    data: param,
    that: that,
    loading: true
  });
}
// 支付下单
export function wechatPayCreateOrder (param, that) {
  return $post({
    url: 'wechatPay/createOrder',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 获取订单支付状态
export function wechatPayGetOrder (param, that) {
  return $get({
    url: 'wechatPay/getOrder',
    method: 'get',
    data: param,
    that: that,
    loading: false
  });
}
// 获取支付记录
export function paymentList (param, that) {
  return $post({
    url: 'payment/list',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 获取图片
export function getPicture (param, that) {
  return $post({
    url: 'session/getPicture_Dall_e_3',
    method: 'post',
    data: param,
    that: that,
    loading: false
  });
}
// 历史获取语音
export function getossGetTmpUrl (param, that) {
  return $post({
    url: 'oss/getTmpUrl',
    method: 'post',
    data: param,
    that: that,
    loading: false
  });
}
// 上传微信语音
export function getuploadWechatAudioFile (param, that) {
  return $post({
    url: 'oss/uploadWechatAudioFile',
    method: 'post',
    data: param,
    that: that,
    loading: false
  });
}
// 合成语音
export function getuploadWavContent (param, that) {
  return $post({
    url: 'oss/uploadWavContent',
    method: 'post',
    data: param,
    that: that,
    loading: false
  });
}
// // 提交视频任务
// export function getsubmitVideo (param, that) {
//   return $post({
//     url: 'session/submitVideo',
//     method: 'post',
//     data: param,
//     that: that
//   });
// }
// 根据taskID获取视频任务
export function getVideo (param, that) {
  return $post({
    url: 'session/getVideo',
    method: 'post',
    data: param,
    that: that,
    loading: false
  });
}
// 发验证码
export function getsendModifyMobileCode (param, that) {
  return $post({
    url: 'user/sendModifyMobileCode',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 绑定手机号
export function getmodifyMobileNo (param, that) {
  return $post({
    url: 'user/modifyMobileNo',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 切换主题
export function configmodify (param, that) {
  return $post({
    url: 'user/config/modify',
    method: 'post',
    data: param,
    that: that,
    loading: false
  });
}
// 提交视频任务
export function submitVideo (param, that) {
  return $post({
    url: 'session/submitVideo',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 获取视频我的创作
export function getMycreation (param, that) {
  return $post({
    url: 'session/getMycreation',
    method: 'post',
    data: param,
    that: that,
    loading: false
  });
}
// 删除视频
export function clearByRecordId (param, that) {
  return $post({
    url: 'session/clearByRecordId',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 获取指定类型和数量的 随机字典
export function getDictionaryByNum (param, that) {
  return $get({
    url: 'app/DictionaryByNum',
    method: 'get',
    data: param,
    that: that,
    loading: false
  });
}
// 提交图片任务
export function submitDalle3 (param, that) {
  return $post({
    url: 'session/submitDalle3',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 提交图片任务
export function submitImageTask (param, that) {
  return $post({
    url: 'session/submitImageTask',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 获取图片我的创作
export function getMycreationPicture (param, that) {
  return $post({
    url: 'session/getMyImageCreation',
    method: 'post',
    data: param,
    that: that,
    loading: false
  });
}
// 获取图片我的创作
export function getimage2Video (param, that) {
  return $post({
    url: 'session/image2Video',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
export function getSseInfo (param, that) {
  return $get({
    url: 'session/sseInfo',
    method: 'get',
    data: param,
    that: that,
    loading: true
  });
}

export function saveMessage (param, that) {
  return $post({
    url: 'session/saveMessage',
    method: 'post',
    data: param,
    that: that,
    loading: false
  });
}
export function getTtsToken (param, that) {
  return $post({
    url: 'chat/getTtsToken',
    method: 'post',
    data: param,
    that: that,
    loading: false
  });
}
// 发验证码
export function sendMobileLoginCode (param, that) {
  return $post({
    url: 'user/sendMobileLoginCode',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 发验证码
export function mobileLogin (param, that) {
  return $post({
    url: 'user/mobileLogin',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// MJ生成图片
export function submitMJImageTask (param, that) {
  return $post({
    url: 'session/submitMJImageTask',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// Midjourney动作任务提交
export function submitMJAction (param, that) {
  return $post({
    url: 'session/submitMJAction',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 获取音色列表
export function submitVoice (param, that) {
  return $get({
    url: 'session/voice',
    method: 'get',
    data: param,
    that: that,
    loading: true
  });
}
// 获取广场榜单
export function plazaBoard (param, that) {
  return $get({
    url: 'appType/plazaBoard',
    method: 'get',
    data: param,
    that: that,
    loading: false
  });
}
// 获取首页列表
export function HomeAppList (param, that) {
  return $get({
    url: 'appType/HomeAppList',
    method: 'get',
    data: param,
    that: that,
    loading: true
  });
}
// 点赞
export function plazaBoardLike (param, that) {
  return $get({
    url: 'appType/plazaBoardLike',
    method: 'get',
    data: param,
    that: that,
    loading: false
  });
}
// 获取我的创作分页
export function getMyCreationPaged (param, that) {
  return $get({
    url: 'session/getMyCreationPaged',
    method: 'get',
    data: param,
    that: that,
    loading: false
  });
}
// 获取oss临时上传文件凭证
export function getStsTokenOSS (param, that) {
  return $post({
    url: 'oss/getStsToken',
    method: 'post',
    data: param,
    that: that,
    loading: false
  });
}
// 百度AI成片
export function AIGenerateVideo (param, that) {
  return $post({
    url: 'session/AIGenerateVideo',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 百度音色试听
export function textToVoice (param, that) {
  return $post({
    url: 'session/textToVoice',
    method: 'post',
    data: param,
    that: that,
    loading: false
  });
}
// 获取文件夹列表
export function folderList (param, that) {
  return $get({
    url: 'material/folderList',
    method: 'get',
    data: param,
    that: that,
    loading: true
  });
}
// 添加文件夹
export function folderAdd (param, that) {
  return $post({
    url: 'material/folder/add',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 修改文件夹
export function folderModify (param, that) {
  return $post({
    url: 'material/folder/modify',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 删除文件夹
export function folderDel (param, that) {
  return $post({
    url: 'material/folder/del',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 删除文件夹
export function folderFile (param, that) {
  return $get({
    url: 'material/folder/file',
    method: 'get',
    data: param,
    that: that,
    loading: true
  });
}
// 删除文件夹
export function folderfileDel (param, that) {
  return $post({
    url: 'material/folder/file/del',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 删除文件夹
export function folderfileadd (param, that) {
  return $post({
    url: 'material/folder/file/add',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 即梦生图任务提交
export function submitJMImageTask (param, that) {
  return $post({
    url: 'session/submitJMImageTask',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 获取加盟商品
export function wechatPaygood (param, that) {
  return $get({
    url: 'wechatPay/goods',
    method: 'get',
    data: param,
    that: that,
    loading: true
  });
}
// 获取排行榜
export function jointop (param, that) {
  return $post({
    url: 'join/top',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 绑定邀请码
export function joinlinkInviteCode (param, that) {
  return $post({
    url: 'join/linkInviteCode',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 佣金明细
export function joinlist (param, that) {
  return $post({
    url: 'join/list',
    method: 'post',
    data: param,
    that: that,
    loading: false
  });
}
// 加盟用户信息
export function joininfo (param, that) {
  return $post({
    url: 'join/info',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 加盟微信提现
export function withdrawForFranchise (param, that) {
  return $post({
    url: 'wechatPay/withdrawForFranchise',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 可灵生图任务提交
export function submitKlingImageTask (param, that) {
  return $post({
    url: 'session/submitKlingImageTask',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 可灵生图任务提交
export function submitDoubaoImageAsyncTask (param, that) {
  return $post({
    url: 'session/submitDoubaoImageAsyncTask',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// 豆包5.0生图任务提交
export function submitSeedreamImageTask (param, that) {
  return $post({
    url: 'session/submitSeedreamImageTask',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
// GPT Image 2生图任务提交
export function submitGptImage2Task (param, that) {
  return $post({
    url: 'session/submitGptImage2Task',
    method: 'post',
    data: param,
    that: that,
    loading: true
  });
}
